import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { it as itLocale } from "date-fns/locale";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const toDate = (value, fmt) => {
  if (!value) return undefined;
  const d = fmt === "it" ? parse(value, "dd/MM/yyyy", new Date()) : new Date(String(value).slice(0, 10));
  return isValid(d) ? d : undefined;
};

/**
 * Selettore data uniforme (calendario shadcn, locale italiano).
 * value/onChange come stringa: "yyyy-MM-dd" (default) o "dd/MM/yyyy" (valueFormat="it").
 */
export function DatePickerField({ value, onChange, valueFormat = "iso", disablePast = false,
  placeholder = "Seleziona data...", testid, className = "", allowClear = true, short = false }) {
  const [open, setOpen] = useState(false);
  const selected = toDate(value, valueFormat);
  const label = selected ? format(selected, short ? "dd/MM/yyyy" : "EEEE d MMMM yyyy", { locale: itLocale }) : "";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`h-12 w-full flex items-center justify-between gap-2 px-3 rounded-lg border-2 border-slate-300 bg-white text-left text-base hover:border-brand/50 focus:outline-none focus:ring-2 focus:ring-brand/30 ${className}`}>
          <span className={`truncate ${short ? "" : "capitalize"} ${selected ? "text-slate-800 font-semibold" : "text-slate-400"}`}>
            {selected ? label : placeholder}
          </span>
          <span className="flex items-center gap-1 shrink-0">
            {allowClear && selected && (
              <span role="button" tabIndex={-1} data-testid={testid ? `${testid}-clear` : undefined}
                onClick={(e) => { e.stopPropagation(); onChange(""); }}
                className="text-slate-400 hover:text-red-600" title="Rimuovi data">
                <X className="w-4 h-4" />
              </span>
            )}
            <CalendarIcon className="w-4 h-4 text-brand" />
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={testid ? `${testid}-popover` : undefined}>
        <Calendar mode="single" locale={itLocale} selected={selected} defaultMonth={selected}
          disabled={disablePast ? { before: new Date(new Date().setHours(0, 0, 0, 0)) } : undefined}
          onSelect={(d) => {
            onChange(d ? format(d, valueFormat === "it" ? "dd/MM/yyyy" : "yyyy-MM-dd") : "");
            setOpen(false);
          }} />
      </PopoverContent>
    </Popover>
  );
}
